import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ParticipationComponent } from './participation/participation.component';
import { AuthGuard } from './_auth/auth-guard';
import {OfflineComponent} from './pm-controls/offline/offline.component';
import { StorageServiceModule } from 'ngx-webstorage-service'

const routes: Routes = [
  { path: 'survey1.aspx', component: ParticipationComponent, canActivate: [AuthGuard]},
  { path: 'offline.aspx', component: OfflineComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes),StorageServiceModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
